import { RecordKind } from '../../record.js';
export class DataFile {
    constructor(doc) {
        this.doc = doc;
    }
    accept(visitor) {
        if (this.doc && this.doc.kind) {
            switch (this.doc.kind) {
                case RecordKind.Option: {
                    visitor.visitOption(this.doc);
                    break;
                }
                case RecordKind.OptionGroup: {
                    visitor.visitOptionGroup(this.doc);
                    break;
                }
                case RecordKind.Product: {
                    visitor.visitProduct(this.doc);
                    break;
                }
                case RecordKind.ProductGroup: {
                    visitor.visitProductGroup(this.doc);
                    break;
                }
                case RecordKind.OclConstraint: {
                    visitor.visitOclConstraint(this.doc);
                    break;
                }
                case RecordKind.OclFilter: {
                    visitor.visitOclFilter(this.doc);
                    break;
                }
                case RecordKind.JsFilter: {
                    visitor.visitJsFilter(this.doc);
                    break;
                }
                case RecordKind.ExternalField: {
                    visitor.visitExternalFiled(this.doc);
                    break;
                }
                case RecordKind.CompatibilityTable: {
                    visitor.visitCompatibilityTable(this.doc);
                    break;
                }
                default:
                    console.log('Doc kind is not defined : ' + this.doc.kind);
            }
        }
    }
}
//# sourceMappingURL=DataFile.js.map